import { reactive } from "vue";
import { getMe, type UserSession } from "./api";

export const authState = reactive<{ user: UserSession | null; checked: boolean }>({
  user: null,
  checked: false,
});

// 管理员名单（Lark 显示名）。服务端是权限的最终裁决者，这里仅用于前端显隐高权限操作。
export const ADMIN_NAMES = ["DevilBao"];
export function isAdmin(): boolean {
  return !!authState.user && ADMIN_NAMES.includes(authState.user.name);
}

export async function ensureAuth() {
  if (authState.checked) return authState.user;
  try {
    authState.user = (await getMe()).user;
  } catch {
    authState.user = null;
  } finally {
    authState.checked = true;
  }
  return authState.user;
}

export function setAuthenticatedUser(user: UserSession | null) {
  authState.user = user;
  authState.checked = true;
}
